import { defineStore } from 'pinia'
import VueScrollTo from 'vue-scrollto'

export const useFlashMessages = defineStore('flashMessages', {
  state: (): FlashMessage => ({
    message: null,
    type: 'info',
    scope: 'global',
    expire: 10_000,
    container: null,
  }),
  getters: {
    hasNotice: (state) => state.message,
    isGlobal: (state) => state.scope === 'global',
    success: (state) => state.type === 'success',
    info: (state) => state.type === 'info',
    warning: (state) => state.type === 'warning',
    error: (state) => state.type === 'error',
    noticeType: (state) => state.type,
  },
  actions: {
    resetNotice() {
      this.container = null
      this.message = null
      this.type = null
      this.scope = 'global'
    },
    scroll() {
      useDebounceFn(() => {
        VueScrollTo.scrollTo('#flashMessageNotice', 500, {
          container: this.container ?? document.body,
        })
      }, 0.3)()
    },
    setNotice(props: Replace<FlashMessage, { message: string }>) {
      this.message = props.message
      this.type = props.type
      this.container = props.container ?? null

      if (props.scope) {
        this.scope = props.scope
      }

      this.scroll()

      setTimeout(() => this.resetNotice(), props.expire ?? this.expire)
    },
    setLocalNotice(
      props: Omit<Replace<FlashMessage, { message: string }>, 'scope'>,
    ) {
      this.scope = 'local'
      this.message = props.message
      this.type = props.type
      this.container = props.container ?? null

      this.scroll()

      setTimeout(() => this.resetNotice(), props.expire ?? this.expire)
    },
  },
})

interface FlashMessage {
  message?: string | null
  type?: 'success' | 'info' | 'warning' | 'error' | null
  scope?: 'global' | 'local'
  expire?: number
  container?: string | null
}
